// Copyright 2022 - 2023 Fewcha. All rights reserved.

import { useAppDispatch, useAppSelector } from "app/hooks";
import icon_close from "assets/images/svg/icon_close.svg";
import { closeSuccessPopup, selectWallet } from "features/wallet/walletReducer";
import React from "react";
import Modal from "react-modal";
import { configModal } from "services/utils";

const Success: React.FC = () => {
  const wallet = useAppSelector(selectWallet);
  const dispatch = useAppDispatch();

  const close = () => dispatch(closeSuccessPopup());

  return (
    <Modal
      isOpen={wallet.isShowSuccessPopup}
      style={configModal()}
      contentLabel="Notify Success"
      onRequestClose={close}
    >
      <div className="w-[420px] p-4 bg-[#000] text-white">
        <div className="flex justify-end hover:cursor-pointer " title="Close" onClick={close}>
          <img src={icon_close} alt="Close Notify" className="w-6 h-6" />
        </div>
        <img
          src={require("../../assets/images/svg/success.png")}
          alt="Success"
          className="w-[60px] h-[60px] mx-auto mb-4"
        />
        <h3 className="text-center text-[28px] leading-[120%] font-medium mt-1 mb-4 ">Congratulation!</h3>
        <p className="text-center px-7 font-medium mb-3">
          Your Fewcha DAO Ring NFT has been claimed successfully. Check and refresh your Fewcha wallet as it might not
          appear immediately
        </p>

        <img alt={`${wallet.currentToken.name}`} src={wallet.currentToken.image} width="48%" className="mx-auto" />
        <p className="text-center text-xl">
          Tier: <strong>{wallet.currentToken.tier}</strong>
        </p>
        <div className="mt-6 flex justify-around mb-2">
          <a
            href={`https://explorer.aptoslabs.com/txn/${wallet.mintHash}?network=${wallet.networkName.toLowerCase()}`}
            target="_blank"
            rel="noreferrer"
            className="bg-[#5200FF] hover:opacity-[0.9] rounded-[100px] px-4 py-1"
          >
            Check on Aptos
          </a>
          <p
            onClick={() => {
              close();
              (window as any).scrollTo({
                top: Math.floor((window as any).document.body.scrollHeight - 1150),
                behavior: "smooth",
              });
            }}
            className="bg-[#5200FF] hover:opacity-[0.9] rounded-[100px] px-4 py-1 hover:cursor-pointer"
          >
            View my perks
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default Success;
